'use client';

import dynamic from 'next/dynamic';

export const KuecheCo = dynamic(
  () => import(/* webpackChunkName: 'KuecheCo' */ './KuecheCo.client').then((mod) => mod.KuecheCo),
  {
    ssr: false,
  },
);
